import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { InputBox } from '../../../../../../components';
import Layout from '../../Layout';
import { CategoryLevels, LevelsType } from '../lib';

import { MdWarning } from 'react-icons/md';
import { ObjetiveMargin } from '../lib/types';
import { SetupIPACategoryLevelsCategoryLevelsMessage } from './SetupIPACategoryLevelsCategoryLevelsMessage';
import styles from './SetupIPACategoryLevelsOptimizationCategory.module.scss';

const { Section, Title, Subtitle } = Layout;
const { Error, Select } = InputBox;

interface SetupIPACategoryLevelsOptimizationCategoryProps {
    form: UseFormReturn<CategoryLevels>;
    segments: LevelsType[];
    queryOptimizationCategory: ObjetiveMargin | undefined;
}

export const SetupIPACategoryLevelsOptimizationCategory = ({ form, segments, queryOptimizationCategory }: SetupIPACategoryLevelsOptimizationCategoryProps) => {
    const optimizationLevelSaved = queryOptimizationCategory?.field;
    const selectedValue = form.watch('optimizationCategory');

    const showWarning = selectedValue && optimizationLevelSaved && optimizationLevelSaved !== selectedValue?.field;
    return (
        <Section.Root>
            <Section.Header>
                <Title>Nível de aplicação da otimização de preços</Title>
                <Subtitle>Defina em qual nível da árvore de categorias a otimização de preços será aplicada.
                    Essa escolha impacta a definição de regras, metas e estratégias de precificação.</Subtitle>
            </Section.Header>

            <Section.Content>
                <Controller
                    control={form.control}
                    name="optimizationCategory"
                    render={({ field, fieldState: { error } }) => {
                        return (
                            <div>
                                <InputBox className={styles.container}>
                                    <Select
                                        data={segments}
                                        onChange={(selectedOption) => {
                                            if (typeof selectedOption === 'string') {
                                                const selected = segments.find((option) => option.field === selectedOption);
                                                field.onChange(selected || null);
                                            } else {
                                                field.onChange(selectedOption);
                                            }
                                        }}
                                        value={field.value?.field}
                                        searchable={false}
                                        cleanable={false}
                                        defaultValue={segments[2]?.name}
                                    />
                                    <Error message={error?.message} />
                                </InputBox>
                            </div>
                        );
                    }}
                />
                {showWarning && (
                    <SetupIPACategoryLevelsCategoryLevelsMessage>
                        <MdWarning size={20} color="#FFB800" />
                        <div>
                            <strong>Atenção!</strong>
                            <p>
                                Ao alterar o nível da estrutura mercadológica, todas as otimizações ativas vinculadas ao nível anterior serão inativadas.
                                Será necessário criar novas otimizações com base no novo nível selecionado.
                            </p>
                        </div>
                    </SetupIPACategoryLevelsCategoryLevelsMessage>
                )}
            </Section.Content>
        </Section.Root>
    );
};
